import React from 'react';
import SearchIcon from '../../images/icons/search.svg';

const SearchBar = ({ handleSearch, search, placeholder, additionalClassName = '' }) => {
  const classNames = `w-64 pl-1 ${additionalClassName}`;
  return (
    <>
      <div style={{ border: '1px solid #838383' }} className="search-icon searchBar flex pl-1 pr-2 rounded-lg">
        <img src={SearchIcon} alt="search" />
        <input
          className={classNames}
          id="textField"
          style={{ border: 'none' }}
          onChange={(e) => handleSearch(e.target.value)}
          size="small"
          value={search}
          placeholder={placeholder}
          autoComplete="off"
        />
      </div>
    </>
  );
};

export default SearchBar;
